import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {memo} from 'react';

import EntityPreview from '@/components/EntityPreview';
import {useGetOneCNAENomenclator} from '@/modules/configuration/hooks/useCNAENomenclator';
import style from '@/modules/proposalRequest/components/ProposalActivitiesSelect/index.less';
import CNAProperties from '@/modules/verification/components/CNAProperties';

const mapTitle = (text, v) => {
  return `(${v?.code}) ${v?.name}`;
};

const ActivityItem = ({data, element, onlyRead, onRemove, indexKey, ...props}) => {

  return (<div
    className={classNames('flex items-center w-full rounded mb-1', {'px-3': !onlyRead}, {[style.classItem]: !onlyRead})}>
    <EntityPreview
      extraDetails={(value) => <CNAProperties value={value}/>}
      truncate
      value={data?.data || element || element?.id}
      uppercase
      useHook={useGetOneCNAENomenclator}
      boldText={!onlyRead}
      onRemove={onRemove ? () => onRemove(element?.id || element, indexKey, data) : null}
      transformTitle={mapTitle}
      {...props}/>
  </div>);


};

ActivityItem.propTypes = {
  data: PropTypes.any,
  element: PropTypes.any,
  onlyRead: PropTypes.bool,
  indexKey: PropTypes.number,
  onRemove: PropTypes.any,
};

export default memo(ActivityItem);
